import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

interface ResetPasswordParams {
	token: string;
	password: string;
}

export const useResetPassword = () => {
	return useMutation({
		mutationFn: async ({ token, password }: ResetPasswordParams) => {
			await api.put(`/user/recover/${token}`, { password }).catch((error) => {
				throw toApiError(error, 'Erro ao redefinir senha');
			});
		},
		onError: (error) => {
			console.error('Erro ao redefinir senha:', getApiErrorMessage(error, 'Erro ao redefinir senha'));
		},
	});
};
